module.exports = __webpack_public_path__ + "img/ch56.79e6187a.png";